export default [
    {
        path: '/user/role',
        props: true,
        component: () => import('@/views/User/Role'),
    },
];